// @flow
import messages from '../messages';

export const buildIncomeFields = ({
  intl,
  showHouseholdIncome,
}: {
  intl: Object,
  showHouseholdIncome: boolean,
}): Array<Object> => [
  {
    variant: 'currency',
    name: 'householdAnnualIncome',
    label: intl.formatMessage(messages.householdAnnualIncome),
    rules: { required: true, min: 0 },
    hidden: !showHouseholdIncome,
    GridProps: { xs: 12, sm: 6 },
  },
  {
    // Fills out the income row so the two counts start one of their own, and so
    // leaves with it rather than holding a gap open.
    variant: 'space',
    hidden: !showHouseholdIncome,
    GridProps: {
      xs: 12,
      sm: 6,
      sx: { display: { xs: 'none', sm: 'block' } },
    },
  },
  {
    variant: 'number',
    name: 'adults',
    label: intl.formatMessage(messages.adults),
    helperText: intl.formatMessage(messages.adultsHelperText),
    rules: { required: true, min: 0 },
    GridProps: { xs: 12, sm: 6 },
  },
  {
    variant: 'number',
    name: 'minors',
    label: intl.formatMessage(messages.minors),
    helperText: intl.formatMessage(messages.minorsHelperText),
    rules: { required: true, min: 0 },
    GridProps: { xs: 12, sm: 6 },
  },
];
